export const NOT_DELIVERABLE = 'NOT_DELIVERABLE';
export const ZERO_RESULTS = 'ZERO_RESULTS';
export const EMPTY_STRING = '';
